const CONFIG = {
  API_HOST: String(import.meta.env.VITE_API_HOST ?? ''),
  MVP_API_BASE_URL: String(import.meta.env.VITE_MVP_API_BASE_URL ?? ''),
  API_TIMEOUT: Number(import.meta.env.VITE_API_TIMEOUT ?? 5000),
  API_BASE_PATH: String(import.meta.env.VITE_API_BASE_PATH ?? ''),
  GRAB_MODAL_HELP_CENTER:
    'https://help.grab.com/driver/id-id/360025236612-Program-GrabModal-Narik',
  GRAB_MODAL_HELP_PHONE_NUMBER:
    'https://help.grab.com/driver/id-id/115007920807',
};

export const {
  API_HOST,
  API_TIMEOUT,
  API_BASE_PATH,
  MVP_API_BASE_URL,
  GRAB_MODAL_HELP_CENTER,
  GRAB_MODAL_HELP_PHONE_NUMBER,
} = CONFIG;
